import Slider from "shared/components/Slider";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { setFilters } from "features/krpano/details-slice";
import { useCallback } from "react";
import { RootState } from "app/store";
import { useDebounce } from "shared/hooks/helpers";
import { ZFilterPlugin } from "krpano";
import { BaseSliderWrapperProps } from "../colourFiltersModels";

interface SliderWrapperProps extends BaseSliderWrapperProps {
  property: Exclude<
    keyof RootState["krpano"]["plugins"]["zfilter"],
    "rgbvimode" | "maskelement"
  >;
}

export const SliderWrapper: React.FC<SliderWrapperProps> = ({
  min,
  max,
  // default,
  step,
  property,
}) => {
  // Plugin, State, and Dispatch
  const plugin = window.krpano.plugin.getItem<ZFilterPlugin>("zfilter");
  // IDEA: This would require less error checking and may still be responsive
  // for number values ```krpano.tween(`plugin[zfilter].${property}`, value)```
  const pluginNotLoaded = !plugin?.loaded;
  const value = useAppSelector(
    (state) => state.krpano.plugins.zfilter[property]
  );
  const dispatch = useAppDispatch();

  // Callbacks
  const setFilterValue = useCallback(
    (newValue: number) => {
      dispatch(setFilters({ [property]: newValue }));

      try {
        if (plugin) {
          plugin[property] = newValue;
        }
      } catch (error) {
        console.error("Error setting dropdown value in plugin:", error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, pluginNotLoaded]
  );

  // Debounce with very short delay to avoid too many updates
  const debouncedCall = useDebounce(setFilterValue, 10);

  return (
    <Slider
      min={min}
      max={max}
      value={value}
      step={step}
      onChange={debouncedCall}
      // onChange={setFilterValue}
      disabled={pluginNotLoaded}
    />
  );
};
